import type { NavbarPreviousPageButtonFragment } from "../client/generated";
import { useTranslation } from "react-i18next";
import { mdiChevronLeft } from "@mdi/js";
import { NavbarButton } from "../shell/NavbarButton";
import { NavbarButtonIcon } from "../shell/NavbarButtonIcon";
import { routingPaths } from "../navigation/constants";
import { useNavigateTransition } from "../navigation/useNavigateTransition";

type Props = {
  fragment?: NavbarPreviousPageButtonFragment;
};

export function NavbarPreviousPageButton({ fragment }: Props) {
  const { t } = useTranslation();
  const [isPending, navigate] = useNavigateTransition();

  const onClick = () => {
    if (fragment && fragment.previousPage) {
      navigate(
        routingPaths.documentPage(
          fragment.document.id,
          fragment.previousPage.id,
        ),
      );
    }
  };

  return (
    <NavbarButton
      tooltip={t("NavbarPreviousPageButton.tooltip")}
      loading={isPending}
    >
      <NavbarButtonIcon
        path={mdiChevronLeft}
        disabled={!fragment?.previousPage}
        onClick={onClick}
      />
    </NavbarButton>
  );
}
